PENCIL